// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const CreateLayoutModalFooter = props =>
    <div className='layout-modal-footer'>
        <button onClick={props.onCancel}>
            <FormattedMessage id='CANCEL'/>
        </button>
        <button
            className='button-primary'
            onClick={props.onSave}
        >
            <FormattedMessage id='SAVE'/>
        </button>
    </div>;

CreateLayoutModalFooter.displayName = 'CreateLayoutModalFooter';
CreateLayoutModalFooter.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
};

export default CreateLayoutModalFooter;



// WEBPACK FOOTER //
// ./src/reports/shared/components/report-variant-modals/create-layout-modal/create-layout-modal-footer.js